import css from 'styled-jsx/css';
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .pagination {
    margin-top: 15px;
    margin-bottom: 15px;
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
  }


  .pagination button {
    padding: 2px 15px;
    width: 3rem;
    height: 3rem;
    display: flex;
    align-items: center;
    border: 1px solid #b6b6b6;
    border-radius: 8px;
    background: white;
    margin-right: 10px;
    margin-left: 10px;
    display: flex;
    width: max-content;
  }

  .pagination button:hover {
    background: #e6f5fd 0% 0% no-repeat padding-box;
    border-radius: 8px;
    border: 1px solid #e6f5fd;
  }

  .pagination button:active {
    background: #e6f5fd 0% 0% no-repeat padding-box;
    border-radius: 8px;
    border: 1px solid #e6f5fd;
  }

  .pagination button:focus {
    outline: none;
    background: #e6f5fd 0% 0% no-repeat padding-box;
    border-radius: 8px;
    border: 1px solid #e6f5fd;
  }

  .pagination :global(button:focus-visible) {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    outline-offset: 3px;
  }

  @media (max-width: 968px) {
  }
`;
